// extracted by mini-css-extract-plugin
export default {"ubi":"Hyperwebster_ubi__hHjTy","bold":"Hyperwebster_bold__HXCZh","buttons":"Hyperwebster_buttons__KOfD6","input":"Hyperwebster_input__n6Z4H"};